import React from 'react'
import Breadcrumb from '../components/Breadcrumbs'
import { Link } from 'react-router-dom'

function Solutions() {
    return (
        <div>
            <Breadcrumb title="Card Solutions" subtitle="Solutions" />
            
            <section className="service-grid-area pt-120 pb-90">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-12">
                            <div className="section-title text-center mb-50">
                                <h6 className="subtitle">Industry Specific</h6>
                                <h2 className="title">Tailored ID & Card Solutions</h2>
                                <p>We provide specialized identification solutions for healthcare, corporate, retail, and education sectors.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row gy-4">
                        {/* Healthcare */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/solutions/1.jpg" alt="Healthcare Solutions" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Healthcare+Solutions">Healthcare Solutions</Link></h4>
                                    <p>High-quality OP cards, staff ID badges, and patient identification cards designed for durability and hygiene.</p>
                                    <Link to="/contact?interest=Healthcare+Solutions" className="more-btn">Request Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Corporate */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/solutions/2.jpg" alt="Corporate Badges" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Corporate+Badges">Corporate Badges</Link></h4>
                                    <p>Secure access cards and employee badges with advanced technology integration (RFID/NFC).</p>
                                    <Link to="/contact?interest=Corporate+Badges" className="more-btn">Request Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Retail & Loyalty */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/solutions/3.jpg" alt="Retail Loyalty" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Retail+Loyalty">Retail & Loyalty</Link></h4>
                                    <p>Boost customer retention with custom-branded membership, gift, and loyalty cards.</p>
                                    <Link to="/contact?interest=Retail+Loyalty" className="more-btn">Request Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Education */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/solutions/4.jpg" alt="Education ID" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Education+ID">Education ID</Link></h4>
                                    <p>Student and faculty ID cards for schools, colleges, and universities, compatible with library and canteen systems.</p>
                                    <Link to="/contact?interest=Education+ID" className="more-btn">Request Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Events */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/solutions/5.jpg" alt="Event Badges" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Event+Badges">Event Badges</Link></h4>
                                    <p>Large format credential cards and passes for conferences, concerts, and exhibitions.</p>
                                    <Link to="/contact?interest=Event+Badges" className="more-btn">Request Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        {/* Government */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/solutions/6.jpg" alt="Government ID" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Government+ID">Government ID</Link></h4>
                                    <p>Secure, tamper-evident identification for government employees and contractors.</p>
                                    <Link to="/contact?interest=Government+ID" className="more-btn">Request Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default Solutions
